import { LocationRole } from '../../../Api/Locations/locationsApi';

const ROLE_ORDER: LocationRole[] = ['install', 'a', 'z'];
export const ROLE_LABELS: Record<LocationRole, string> = { install: 'Install', a: 'Location A', z: 'Location Z' };
export const BILLING_ADDRESS_LABEL = 'Billing address';

export const roleLabels = (roles: LocationRole[]): string =>
  ROLE_ORDER.filter((role) => roles.includes(role))
    .map((role) => ROLE_LABELS[role])
    .join(', ');
